import { useCallback, useEffect, lazy, Suspense, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { API_BASE_URL, APP_PREFIX_PATH } from "configs/AppConfig";

import Layout from "components/layout/Layout";
import { ConfigProvider } from "antd";
import BusinessEnquiry from "components/page-content/Business-Enquiry/BusinessEnquiry";
import ContactUs from "components/page-content/contact-us/ContactUs";
import PrivacyPolicy from "components/page-content/privacy-policy/PrivacyPolicy";
import TermsofUse from "components/page-content/privacy-policy/TermosofUse";
import ReviewsAndBlogs from "components/page-content/reviewsAndBlogs/ReviewsAndBlogs";
import ReviewDetail from "components/page-content/reviewsAndBlogs/reviewDetail/ReviewDetail";
import BusinessImprovementProgram from "components/page-content/business-improvement-program/BusinessImprovement";
import CaseStudies from "components/page-content/case-studies/CaseStudies";
import CaseStudiesDetail from "components/page-content/case-studies/case-studies-detail/CaseStudiesDetail";
import { constantsActions } from "store-redux/constants-slice";
import AboutUs from "components/page-content/privacy-policy/AboutUs";
import LoaderComponent from "components/page-content/common-component/Loader/Loader";
import { trackPageView } from "analytics";
import AOS from "aos";
import "aos/dist/aos.css";
import Clients from "components/page-content/clients/Clients";
import BodyshopPotential from "pages/business-potential/BodyshopPotential";
import NotFound from "components/not-found/NotFound";

//Define the main pages urls here
const Home = lazy(() => import(`pages/Home`));
const FAQ = lazy(() => import(`pages/FAQ`));
// const AboutUs = lazy(() => import(`pages/AboutUs`));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 2000,
    },
  },
});



const App = () => {
  // access the modalSlice State in the Store Reducer
  const [checkForAuthorization, setCheckForAuthorization] = useState(false);
  const [jsonData, setJsonData] = useState();
  const { settings } = useSelector((state) => state.constants);
  console.log("settings home rrr", settings);
  const message = "Hi, I would like to know more about your services!"; // Optional pre-filled message

  const whatsappLink = `https://wa.me/${
    settings?.whatsAppNumber
  }?text=${encodeURIComponent(message)}`;

  const dispatch = useDispatch();

  const location = useLocation();
  console.log("json data is", jsonData);

  //headerscript and bodyscript
  const [headerScript, setHeaderScript] = useState("");
  const [footerScript, setFooterScript] = useState("");

  useEffect(() => {
    setHeaderScript(settings?.headerScript);
    setFooterScript(settings?.bodyScript);
  }, [settings]);

  useEffect(() => {
    if (!headerScript) return;

    // Use a temporary container to parse all tags (including <noscript>)
    const container = document.createElement("div");
    container.innerHTML = headerScript;

    const appendedScripts = [];
    const appendedNoscripts = [];

    // Process script tags
    const scriptElements = container.querySelectorAll("script");
    scriptElements.forEach((scriptElement) => {
      const script = document.createElement("script");
      script.type = scriptElement.getAttribute("type") || "text/javascript";

      if (scriptElement.src) {
        script.src = scriptElement.src;
        script.async = true;
      } else {
        script.textContent = scriptElement.textContent;
      }

      if (scriptElement.hasAttribute("defer")) {
        script.defer = true;
      }

      if (scriptElement.hasAttribute("referrerpolicy")) {
        script.referrerPolicy = scriptElement.getAttribute("referrerpolicy");
      }

      document.head.appendChild(script);
      appendedScripts.push(script);
    });

    // Process noscript tags (preserved now)
    // const noscriptElements = container.querySelectorAll("noscript");
    // noscriptElements.forEach((noscriptEl) => {
    //   const wrapper = document.createElement("div");
    //   wrapper.innerHTML = noscriptEl.innerHTML;
    //   //wrapper.style.display = "none"; // optional: visually hidden
    //   document.body.appendChild(wrapper);
    //   appendedNoscripts.push(wrapper);
    // });

    // Cleanup
    return () => {
      appendedScripts.forEach((script) => {
        document.head.removeChild(script);
      });
      // appendedNoscripts.forEach((el) => {
      //   document.body.removeChild(el);
      // });
    };
  }, [headerScript]);

  useEffect(() => {
    if (!footerScript) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(footerScript, "text/html");

    // Process <script> tags
    const scriptElements = doc.querySelectorAll("script");
    const appendedScripts = [];

    scriptElements.forEach((scriptElement) => {
      const script = document.createElement("script");
      script.type = scriptElement.getAttribute("type") || "text/javascript";

      if (scriptElement.src) {
        script.src = scriptElement.src;
        script.async = true;
      } else {
        script.textContent = scriptElement.textContent;
      }

      if (scriptElement.hasAttribute("defer")) {
        script.defer = true;
      }

      if (scriptElement.hasAttribute("referrerpolicy")) {
        script.referrerPolicy = scriptElement.getAttribute("referrerpolicy");
      }

      document.body.appendChild(script);
      appendedScripts.push(script);
    });

    // Process <noscript> (for preserving in DOM, optional)
    // const noscriptElements = doc.querySelectorAll("noscript");
    // const appendedNoscripts = [];

    // noscriptElements.forEach((noscriptEl) => {
    //   const wrapper = document.createElement("div");
    //   wrapper.innerHTML = noscriptEl.innerHTML; // not actual <noscript>, just a div
    //   wrapper.style.display = "none"; // hide it, just in case
    //   document.body.appendChild(wrapper);
    //   appendedNoscripts.push(wrapper);
    // });

    return () => {
      appendedScripts.forEach((script) => {
        document.head.removeChild(script);
      });
      // appendedNoscripts.forEach((el) => {
      //   document.body.removeChild(el);
      // });
    };
  }, [footerScript]);

  //google analytics

  useEffect(() => {
    // Track the current page
    trackPageView(location.pathname + location.search);
  }, [location]);

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  const fetchSettings = async () => {
    const response = await fetch(`${API_BASE_URL}contact-details/get/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    dispatch(
      constantsActions.toggleSettings({ settings: { ...data?.data[0] } })
    );

    console.log("settings rrr", data);

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // useEffect(() => {
  //   AOS.init({
  //     duration: 1200, // Animation duration in milliseconds
  //     offset: 100,    // Offset from the viewport for triggering animations
  //     once: true,     // Ensures animation happens only once
  //   });
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await fetch(`${API_BASE_URL}home/generate-file`);

        // const data = await response.json();
        // const fileUrl = data.fileUrl;

        const fileUrl =
          "https://bodyshopguru-live.s3.ap-south-1.amazonaws.com/home-file.txt";

        // Fetch the text file
        const textResponse = await fetch(fileUrl, {
          method: "GET",
          headers: {
            "Cache-Control": "no-cache",
          },
          cache: "no-cache",
        });
        console.log("text response is", textResponse);

        const textData = await textResponse.text();
        console.log("text data is", textData);
        const parsedData = JSON.parse(textData);
        console.log("parsed data", parsedData);
        const widgets = parsedData?.widgets;
        console.log("widgets in app.js", widgets);
        dispatch(
          constantsActions.toggleConstants({ widgets: parsedData?.widgets })
        );

        setJsonData(parsedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   // auto login first time app is running
  //   autoLoginHandler();
  //   setCheckForAuthorization(true);
  // }, [autoLoginHandler]);

  // Scroll to top whenever the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: "#FF6666",
            colorTextPlaceholder: "#A1A1A1",
            // borderRadius: 2,

            // Alias Token
            // colorBgContainer: '#f6ffed',
          },
        }}
      >
        <QueryClientProvider client={queryClient}>
          {/* Defined seperate routes to avoid coming under Layout component */}
          {/* <Routes>
           <Route
            path={`${APP_PREFIX_PATH}/business-enquiry`}
            element={
              <Suspense fallback={<LoaderComponent />}>
                <BusinessEnquiry />
              </Suspense>
            }
          /> */}
          <Layout
            isDashboard={
              location.pathname.includes("dashboard") ||
              location.pathname.includes("profile")
            }
            // notScrollable={modalIsVisible}
          >
            {/* Define Routes and corresponding components of main pages */}
            <Routes>
              <Route
                path={`${APP_PREFIX_PATH}`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <Home />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/FAQ`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <FAQ />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/bodyshop-potential`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <BodyshopPotential />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/contact-us`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <ContactUs />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/information-policy/:slug`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <PrivacyPolicy />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/reviews-and-blogs`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <ReviewsAndBlogs />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/reviews-and-blogs/:slug`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <ReviewDetail />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/pages/:Slug`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <BusinessImprovementProgram />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/case-studies`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <CaseStudies />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/clients`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <Clients />
                  </Suspense>
                }
              />
              <Route
                path={`${APP_PREFIX_PATH}/case-studies/:Slug`}
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <CaseStudiesDetail />
                  </Suspense>
                }
              />
              <Route
                path="*"
                element={
                  <Suspense fallback={<LoaderComponent />}>
                    <NotFound />
                  </Suspense>
                }
              />
            </Routes>
          </Layout>
        </QueryClientProvider>
      </ConfigProvider>
      {settings?.whatsAppNumber && (
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "fixed",
            bottom: "50px",
            right: "50px",
            backgroundColor: "#25D366",
            borderRadius: "50%",
            width: "60px",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            zIndex: 99999999999999999,
          }}
          title="Chat with us on WhatsApp"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
            style={{ width: "30px", height: "30px" }}
            className="whatsapp-chat"
          />
        </a>
      )}
    </>
  );
};

export default App;
